import fetch from 'isomorphic-fetch';

import get from 'lodash/get';

import { responseReceived } from '~/lib/mobile-x';

import { getHeaders } from '~/utils';

export const submitCreditCardApplication = async ({ globalData, requestData: { cardOffer } }) => {

  const { host, protocol } = window.location;

  let data, requestBody;

  requestBody = {
    'creditCardOffer': {
      ...get(cardOffer, 'creditCardOffer'),
    },
    'customerDetails': {
      'personalDetails': {
        firstName: get(cardOffer, 'customerDetails.personalDetails.firstName'),
        lastName: get(cardOffer, 'customerDetails.personalDetails.lastName'),
      },
      'contactDetails': get(cardOffer, 'customerDetails.contactDetails'),
    },
  };

  try {
    data = await submit({
      body: requestBody,
      globalData,
      url: `${protocol}//${host}/api/cc-application`,
    });
  } catch (err) {
    throw Error ('Error in API submitCreditCardApplication');
  }
  return data;
};

const submit = async ({ body, globalData, url }) => {

  let response, data;
  try {
    response = await fetch(url, {
      method: 'post',
      body: JSON.stringify(body),
      headers: getHeaders({
        globalData,
      }),
    });
    responseReceived(get(response, 'status'));
  } catch (err) {
    throw Error('Error in response');
  }
  if (!response.ok) {
    throw Error(response.statusText);
  }
  data = await response.json();
  return data;
};
